import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import moment from 'moment';
import 'moment/locale/id';

export function initTracking() {
  console.log('[Tracking] Initializing Tracking module');

  moment.locale('id');

  // Make sure we have the URLs passed from the view or define them globally
  const trackUrl = window.TRACKING_API_URL || '/tracking/get-locations';
  const historyUrlBase = window.TRACKING_HISTORY_URL || '/tracking/get-user-history';
  const saveRoleUrl = window.TRACKING_SAVE_ROLE_URL || '/tracking/save-role-settings';

  // Base Layers
  var osmLayer = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
    maxZoom: 20,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: '&copy; Google Maps',
  });

  var googleSat = L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
    maxZoom: 22,
    maxNativeZoom: 18,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: '&copy; Google Satellite',
  });

  var googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
    maxZoom: 22,
    maxNativeZoom: 18,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: '&copy; Google Maps',
  });

  var mapElem = document.getElementById('mapTracking');
  if (!mapElem) return;

  // Initialize Map
  var map = L.map('mapTracking', {
    center: [0.5401, 123.0605],
    zoom: 11,
    layers: [googleStreets], // Default layer
  });

  // Add Layer Control
  var baseMaps = {
    'Google Streets': googleStreets,
    'Google Satellite': googleSat,
    OpenStreetMap: osmLayer,
  };
  L.control.layers(baseMaps).addTo(map);

  var markers = {}; // Store markers by user_id
  var polylines = {}; // Store polylines by user_id
  var fetchInterval;

  function fetchLocations() {
    $.ajax({
      url: trackUrl,
      method: 'GET',
      data: $('#filter-tracking-form').serialize(),
      dataType: 'json',
      success: function (res) {
        if (res.status === 'success') {
          try {
            updateMarkers(res.data, res.history || {});
          } catch (e) {
            console.error('Error updating markers: ', e);
            $('#userListContainer').html(
              '<li class="list-group-item text-danger text-center">Gagal merender peta. (JS Error)</li>'
            );
          }
        }
      },
      error: function () {
        console.error('Gagal menarik data lokasi');
        $('#statusIndicator')
          .removeClass('bg-soft-success text-success')
          .addClass('bg-soft-danger text-danger')
          .html('<i class="bi bi-exclamation-triangle me-1"></i> Disconnected');
        $('#userListContainer').html(
          '<li class="list-group-item text-danger text-center">Koneksi terputus.</li>'
        );
      },
    });
  }

  function updateMarkers(locations, historyData) {
    $('#statusIndicator')
      .removeClass('bg-soft-danger text-danger')
      .addClass('bg-soft-success text-success')
      .html('<i class="bi bi-broadcast me-1"></i> Live Auto-Sync');

    var $list = $('#userListContainer');
    $list.empty();

    if (locations.length === 0) {
      $list.append(
        '<li class="list-group-item text-center py-4 text-muted small">Belum ada data lokasi petugas.</li>'
      );
    }

    // Clean up inactive markers
    let activeUserIds = locations.map((l) => l.user_id.toString());
    Object.keys(markers).forEach(function (userId) {
      if (!activeUserIds.includes(userId.toString())) {
        map.removeLayer(markers[userId]);
        delete markers[userId];
      }
    });

    // Clean up inactive polylines
    Object.keys(polylines).forEach(function (userId) {
      if (!activeUserIds.includes(userId.toString())) {
        map.removeLayer(polylines[userId]);
        delete polylines[userId];
      }
    });

    let activeCount = 0;
    let inactiveCount = 0;

    locations.forEach(function (loc) {
      let lat = parseFloat(loc.latitude);
      let lng = parseFloat(loc.longitude);
      if (isNaN(lat) || isNaN(lng)) return;

      let lastUpdated = moment.utc(loc.last_updated).local();
      let diffHours = moment().diff(lastUpdated, 'hours');
      let isOffline = diffHours >= 1;
      let isLowBattery = loc.battery_level !== null && loc.battery_level <= 20;

      if (isOffline) {
        inactiveCount++;
      } else {
        activeCount++;
      }

      // Populate side list
      let statusBadge = isOffline
        ? '<span class="badge bg-secondary" style="font-size:0.6rem;">Offline</span>'
        : '<span class="badge bg-success" style="font-size:0.6rem;">Live</span>';

      let batteryIcon =
        loc.battery_level !== null
          ? `<span class="${isLowBattery ? 'text-danger fw-bold' : 'text-muted'} ms-2" style="font-size:0.75rem;" title="Baterai"><i class="bi bi-battery-${loc.battery_level > 50 ? 'full' : 'half'}"></i> ${loc.battery_level}%</span>`
          : '';

      let displayName = loc.nama_pegawai ? `${loc.nama_pegawai} (${loc.username})` : loc.username;
      let unitInfo =
        loc.nama_up3 || loc.nama_ulp
          ? `<div class="text-muted mb-1" style="font-size: 0.75rem;"><i class="bi bi-building me-1"></i> ${loc.nama_up3 || '-'} - ${loc.nama_ulp || '-'}</div>`
          : '';
      let deviceInfo = loc.device_name
        ? `<div class="text-muted mb-1" style="font-size: 0.75rem;"><i class="bi bi-phone me-1"></i> ${loc.device_name}</div>`
        : '';

      let initials = displayName.substring(0, 2).toUpperCase();

      let listItem = $(`
                <li class="list-group-item px-3 py-3 petugas-item border-bottom" style="cursor:pointer;">
                    <div class="d-flex align-items-center mb-2">
                        <div class="avatar-circle shadow-sm me-3 flex-shrink-0">${initials}</div>
                        <div class="flex-grow-1 overflow-hidden">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div class="fw-bold small text-dark text-truncate">${displayName}</div>
                                ${statusBadge}
                            </div>
                            ${unitInfo}
                            ${deviceInfo}
                        </div>
                    </div>
                    
                    <div class="d-flex justify-content-between align-items-center mt-2 pt-2 border-top border-light">
                        <div class="text-muted" style="font-size: 0.7rem;"><i class="bi bi-clock me-1"></i> ${lastUpdated.fromNow()}</div>
                        <div class="d-flex gap-2 align-items-center">
                            ${batteryIcon}
                            <button class="btn btn-primary btn-sm py-0 px-3 rounded-pill shadow-sm route-btn" style="font-size: 0.65rem;">
                                <i class="bi bi-geo-alt-fill me-1"></i> Rute
                            </button>
                        </div>
                    </div>
                </li>
            `);

      listItem.on('click', function () {
        map.flyTo([lat, lng], 16);
      });
      listItem.find('.route-btn').on('click', function (e) {
        e.stopPropagation();
        window.openHistory(loc.user_id, loc.nama_pegawai || loc.username);
      });

      $list.append(listItem);

      let markerClass = 'custom-marker';
      if (isOffline) markerClass += ' offline';
      else if (isLowBattery) markerClass += ' low-battery';

      let pulseHtml = !isOffline ? '<div class="pulse-ring"></div>' : '';
      let iconHtml = `<div class="d-flex align-items-center justify-content-center">${pulseHtml}<div class="${markerClass}"><i class="bi bi-car-front-fill"></i></div></div>`;

      var customIcon = L.divIcon({
        className: 'custom-div-icon',
        html: iconHtml,
        iconSize: [44, 44],
        iconAnchor: [22, 22],
        popupAnchor: [0, -22],
      });

      let popupContent = `
                <div style="min-width: 180px;">
                    <div class="fw-bold fs-6 mb-0">${loc.nama_pegawai || loc.username}</div>
                    <div class="small text-muted mb-2">@${loc.username}</div>
                    <div class="small mb-1"><i class="bi bi-building"></i> ${loc.nama_up3 || '-'} / ${loc.nama_ulp || '-'}</div>
                    ${loc.device_name ? `<div class="small mb-1"><i class="bi bi-phone"></i> ${loc.device_name}</div>` : ''}
                    <div class="small mb-1"><i class="bi bi-clock"></i> ${lastUpdated.fromNow()}</div>
                    ${loc.speed ? `<div class="small mb-1"><i class="bi bi-speedometer2"></i> ${parseFloat(loc.speed).toFixed(2)} km/h</div>` : ''}
                    ${loc.battery_level !== null ? `<div class="small mb-2"><i class="bi bi-battery-${loc.battery_level > 50 ? 'full' : 'half'}"></i> ${loc.battery_level}%</div>` : ''}
                    <button class="btn btn-primary btn-sm w-100 py-1 rounded-pill mt-2 d-flex align-items-center justify-content-center gap-1" style="font-size: 0.7rem;" onclick="window.openHistory('${loc.user_id}', '${loc.nama_pegawai || loc.username}');">
                        <i class="bi bi-clock-history"></i> Lihat Riwayat Rute
                    </button>
                </div>
            `;

      if (markers[loc.user_id]) {
        markers[loc.user_id].setLatLng([lat, lng]);
        markers[loc.user_id].setIcon(customIcon);
        markers[loc.user_id].getPopup().setContent(popupContent);
      } else {
        markers[loc.user_id] = L.marker([lat, lng], { icon: customIcon })
          .bindPopup(popupContent)
          .addTo(map);
      }

      if (historyData && historyData[loc.user_id] && historyData[loc.user_id].length > 0) {
        let latlngs = [...historyData[loc.user_id]];
        latlngs.push([lat, lng]);

        if (polylines[loc.user_id]) {
          polylines[loc.user_id].setLatLngs(latlngs);
        } else {
          polylines[loc.user_id] = L.polyline(latlngs, {
            color: '#0d6efd',
            weight: 4,
            opacity: 0.8,
            lineCap: 'round',
            lineJoin: 'round',
          }).addTo(map);
        }
      }
    });

    $('#totalPetugas').text(locations.length);
    $('#dashTotalPetugas').text(locations.length);
    $('#dashActivePetugas').text(activeCount);
    $('#dashInactivePetugas').text(inactiveCount);

    applySearchFilter();
  }

  function applySearchFilter() {
    let searchVal = $('#searchPetugas').val().toLowerCase();
    $('#userListContainer li.petugas-item').each(function () {
      let text = $(this).text().toLowerCase();
      if (text.indexOf(searchVal) > -1) {
        $(this).removeClass('d-none');
      } else {
        $(this).addClass('d-none');
      }
    });
  }

  $('#searchPetugas').on('keyup', function () {
    applySearchFilter();
  });

  $('#btnRefreshMap').on('click', function () {
    $(this).find('i').addClass('fa-spin');
    fetchLocations();
    setTimeout(() => {
      $(this).find('i').removeClass('fa-spin');
    }, 1000);
  });

  fetchLocations();
  fetchInterval = setInterval(fetchLocations, 3000);

  setTimeout(function () {
    if (map) map.invalidateSize();
  }, 500);

  var historyMap = null;
  var historyPolyline = null;
  var historyMarkersGroup = L.featureGroup();
  var activeHistoryUserId = null;
  var activeHistoryUserName = '';

  window.openHistory = function (userId, name) {
    activeHistoryUserId = userId;
    activeHistoryUserName = name;

    $('#historyModalLabel').html(
      `<i class="bi bi-clock-history me-2"></i> Riwayat Perjalanan - <strong>${name}</strong>`
    );
    $('#historyDateInput').val(moment().format('YYYY-MM-DD'));

    var myModal = new bootstrap.Modal(document.getElementById('historyModal'));
    myModal.show();
  };

  $('#historyModal').on('shown.bs.modal', function () {
    if (!historyMap) {
      historyMap = L.map('historyMap', {
        center: [0.5401, 123.0605],
        zoom: 11,
      });

      L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 22,
        maxNativeZoom: 18,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        attribution: '&copy; Google Maps',
      }).addTo(historyMap);

      historyMarkersGroup.addTo(historyMap);
    } else {
      historyMap.invalidateSize();
    }

    loadHistoryData();
  });

  $('#historyDateInput').on('change', function () {
    loadHistoryData();
  });

  function loadHistoryData() {
    if (!activeHistoryUserId) return;

    var selectedDate = $('#historyDateInput').val();
    $('#historyMapLoader').removeClass('d-none');
    $('#historyPointsList').html(
      '<div class="text-center py-4"><div class="spinner-border spinner-border-sm text-primary" role="status"></div> Loading...</div>'
    );

    if (historyPolyline) {
      historyMap.removeLayer(historyPolyline);
      historyPolyline = null;
    }
    historyMarkersGroup.clearLayers();

    $.ajax({
      url: historyUrlBase + '/' + activeHistoryUserId,
      method: 'GET',
      data: { date: selectedDate },
      dataType: 'json',
      success: function (res) {
        $('#historyMapLoader').addClass('d-none');

        if (res.status === 'success' && res.data && res.data.length > 0) {
          var points = res.data;
          var latlngs = [];
          var listHtml = '<div class="list-group list-group-flush rounded-3">';

          points.forEach(function (p, index) {
            var lat = parseFloat(p.latitude);
            var lng = parseFloat(p.longitude);
            latlngs.push([lat, lng]);

            var timeStr = moment.utc(p.created_at).local().format('HH:mm:ss');
            var speedStr = p.speed ? `${parseFloat(p.speed).toFixed(2)} km/h` : '-';
            var batteryStr = p.battery_level !== null ? `${p.battery_level}%` : '-';

            var markerColor = '#198754';
            if (p.battery_level !== null && p.battery_level <= 20) markerColor = '#fd7e14';

            var histMarker = L.circleMarker([lat, lng], {
              radius: 6,
              fillColor: markerColor,
              color: '#ffffff',
              weight: 2,
              opacity: 1,
              fillOpacity: 0.9,
            }).bindPopup(`
                            <div class="small">
                                <strong>Waktu:</strong> ${timeStr}<br>
                                <strong>Kecepatan:</strong> ${speedStr}<br>
                                <strong>Baterai:</strong> ${batteryStr}<br>
                                <strong>Device:</strong> ${p.device_name || '-'}
                            </div>
                        `);

            historyMarkersGroup.addLayer(histMarker);

            listHtml += `
                            <a href="#" class="list-group-item list-group-item-action py-2 px-3 border-0 rounded-3 mb-1" onclick="event.preventDefault(); historyMap.setView([${lat}, ${lng}], 18); historyMarkersGroup.getLayers()[${index}].openPopup();">
                                <div class="d-flex justify-content-between align-items-center mb-1">
                                    <span class="fw-bold small text-primary"><i class="bi bi-clock me-1"></i> ${timeStr}</span>
                                    <span class="badge bg-white text-dark border" style="font-size:0.6rem;">Titik #${index + 1}</span>
                                </div>
                                <div class="text-muted d-flex gap-3" style="font-size: 0.7rem;">
                                    <span><i class="bi bi-speedometer2"></i> ${speedStr}</span>
                                    <span><i class="bi bi-battery-half"></i> ${batteryStr}</span>
                                </div>
                            </a>
                        `;
          });

          listHtml += '</div>';
          $('#historyPointsList').html(listHtml);

          historyPolyline = L.polyline(latlngs, {
            color: '#0d6efd',
            weight: 5,
            opacity: 0.8,
            lineCap: 'round',
            lineJoin: 'round',
          }).addTo(historyMap);

          historyMap.fitBounds(historyPolyline.getBounds(), { padding: [30, 30] });
        } else {
          $('#historyPointsList').html(
            '<div class="text-center py-5 text-muted small"><i class="bi bi-geo-alt-fill fs-2 mb-2 d-block text-secondary"></i> Tidak ada riwayat perjalanan pada tanggal ini.</div>'
          );
        }
      },
      error: function () {
        $('#historyMapLoader').addClass('d-none');
        $('#historyPointsList').html(
          '<div class="text-center py-5 text-danger small"><i class="bi bi-exclamation-triangle-fill fs-2 mb-2 d-block"></i> Gagal memuat data.</div>'
        );
      },
    });
  }

  // === Role Settings Save Handler ===
  $('#btnSaveRoleSettings').on('click', function () {
    let $btn = $(this);
    $btn
      .prop('disabled', true)
      .html('<span class="spinner-border spinner-border-sm me-1"></span> Menyimpan...');

    $.ajax({
      url: saveRoleUrl,
      method: 'POST',
      data: $('#formRoleSettings').serialize(),
      dataType: 'json',
      success: function (res) {
        if (res.csrf_token) {
          if ($('meta[name="X-CSRF-TOKEN"]').length) {
            $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
          }
          $('input[name*="csrf_"]').val(res.csrf_token);
        }

        if (res.status === 'success') {
          var myModal = bootstrap.Modal.getInstance(document.getElementById('modalRoleSettings'));
          if (myModal) myModal.hide();

          Swal.fire({
            icon: 'success',
            title: 'Berhasil!',
            text: res.message,
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire('Error', res.message || 'Gagal menyimpan pengaturan', 'error');
        }
      },
      error: function (xhr) {
        Swal.fire('Error', xhr.responseJSON?.message || 'Kesalahan server', 'error');
      },
      complete: function () {
        $btn.prop('disabled', false).html('<i class="bi bi-save me-1"></i> Simpan Pengaturan');
      },
    });
  });

  // === Filter Form Handler ===
  $('#filter-tracking-form').on('submit', function (e) {
    e.preventDefault();
    fetchLocations();
  });

  $('#btn-reset-tracking').on('click', function (e) {
    e.preventDefault();
    const $form = $('#filter-tracking-form');
    $form.find('select').val(null).trigger('change');
    fetchLocations();
  });
}
